import { Component } from '../../../engine/ecs/core/Component';
import { Vector2 } from '../../../engine/ecs/core/Vector2';
import { Direction } from './PacmanComponent';

/**
 * Ghost types with different personalities
 */
export enum GhostType {
  Blinky = 'blinky', // Red - Direct chase
  Pinky = 'pinky', // Pink - Ambush ahead
  Inky = 'inky', // Cyan - Complex behavior
  Clyde = 'clyde', // Orange - Scatter when close
}

/**
 * Ghost AI modes
 */
export enum GhostMode {
  Scatter = 'scatter', // Return to corners
  Chase = 'chase', // Hunt Pacman
  Frightened = 'frightened', // Run away (edible)
  Dead = 'dead', // Return to base
  InBase = 'in_base', // Waiting to leave base
}

/**
 * GhostComponent - Data for ghost AI entities
 * Pure data component following ECS principles
 */
export class GhostComponent extends Component {
  public ghostType: GhostType;
  public mode: GhostMode;
  public currentDirection: Direction;
  public nextDirection: Direction;
  public speed: number;
  public normalSpeed: number;
  public frightenedSpeed: number;
  public deadSpeed: number;

  // AI targeting
  public homeCorner: Vector2;
  public targetPosition: Vector2;
  public basePosition: Vector2;

  // Timers
  public frightenedTimer: number;
  public scatterTimer: number;
  public modeTimer: number;

  // State
  public isEdible: boolean;
  public flashTimer: number;
  public dotCounter: number; // For leaving base logic

  constructor(
    ghostType: GhostType,
    homeCorner: Vector2,
    basePosition: Vector2,
    normalSpeed: number = 120
  ) {
    super();
    this.ghostType = ghostType;
    this.mode = GhostMode.InBase;
    this.currentDirection = Direction.Up;
    this.nextDirection = Direction.Up;

    // Speed settings
    this.normalSpeed = normalSpeed;
    this.frightenedSpeed = normalSpeed * 0.6;
    this.deadSpeed = normalSpeed * 1.5;
    this.speed = this.normalSpeed;

    // Positions
    this.homeCorner = homeCorner;
    this.targetPosition = homeCorner.clone();
    this.basePosition = basePosition;

    // Timers
    this.frightenedTimer = 0;
    this.scatterTimer = 0;
    this.modeTimer = 0;

    // State
    this.isEdible = false;
    this.flashTimer = 0;
    this.dotCounter = 0;
  }

  public clone(): GhostComponent {
    const clone = new GhostComponent(
      this.ghostType,
      this.homeCorner.clone(),
      this.basePosition.clone(),
      this.normalSpeed
    );

    clone.mode = this.mode;
    clone.currentDirection = this.currentDirection;
    clone.nextDirection = this.nextDirection;
    clone.speed = this.speed;
    clone.frightenedSpeed = this.frightenedSpeed;
    clone.deadSpeed = this.deadSpeed;
    clone.targetPosition = this.targetPosition.clone();
    clone.frightenedTimer = this.frightenedTimer;
    clone.scatterTimer = this.scatterTimer;
    clone.modeTimer = this.modeTimer;
    clone.isEdible = this.isEdible;
    clone.flashTimer = this.flashTimer;
    clone.dotCounter = this.dotCounter;

    return clone;
  }
}
